import axios from 'axios'
import {Message} from 'element-ui'
import router from '../../router'
import store from '../../vuex/store'
axios.defaults.baseURL= '';
const http = axios.create({
  headers: {
    clientType: 'PC',
    withCredentials: false,
    "Access-Control-Allow-Origin":"*",
    "Access-Control-Allow-Headers": "Content-Type,XFILENAME,XFILECATEGORY,XFILESIZE",
    "Access-Control-Allow-Methods":"PUT,POST,GET,DELETE,OPTIONS",
    "X-Powered-By":' 3.2.1',
    "Content-Type": "application/json;charset=utf-8",

    Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJjZW50ZXJJZCI6IjAiLCJzdWIiOiLlvpDoibPpnJ4iLCJpc0F1dGgiOnRydWUsImFyZWFJZCI6IjAiLCJyb2xlSWQiOjAsImlzcyI6ImhnIiwiaWQiOiIxMzE4MDM0MzgxMDIyMDQwMDY1IiwiaXNBZG1pbiI6bnVsbCwidXNlclR5cGUiOiIxLDIsMyIsImV4cCI6MTYwMzk0Mjk3MSwiaWF0IjoxNjAzMDc4OTcxLCJqdGkiOiI4ZmFhNzAyYy1iMWFlLTQ0ODUtODVmMy03ZjgzMjcxYjU4MWMifQ.sS5S-6uMkGxzeBMV_1BhpEupWHDiEM75lvW4FK9tVP4'

  },
  timeout: 180 * 1000
});
http.interceptors.request.use((config) => {
  console.log(config)
  try{
    config.headers.Authorization =  localStorage.getItem('token')?'Bearer '+JSON.parse(localStorage.getItem('token')):'';
  }catch(e){
    config.headers.Authorization =  '';
  }
  config.headers.clientType='PC';
  config.headers.imPath=window.location.href.split('#')[1];
  return config
}, (error) => {
  return Promise.reject(error)
})
http.interceptors.response.use((respoens) => {
  console.log(respoens)
  if (respoens.data.status !== 200) {
    Message.error(respoens.data.msg?respoens.data.msg:'失败了')
  }
  if(respoens.data.status === 80808 || (respoens.data.msg && respoens.data.msg.indexOf("登陆已过期") != -1)) {
    store.commit("setIsBreakIM", true);
    window.websock ? window.websock.close() : "";
    store.commit("setAlarmId", "");
    store.commit("clearLoginInfo");
    router.push('/login')
    Message.error(respoens.data.msg)
    return false
  }
  return respoens.data
}, (error) => {

  if (error && error.response) {
    switch (error.response.status) {
      case 500:
        Message.error('与服务器连接失败');
        break
      case 404:
        Message.error('未找到此接口');
        break
      default:
        Message.error('接口错误');
    }
  } else {
    Message.error('连接超时，请刷新页面')
  }
})

http.all = axios.all;


const httpPlugin = {};
httpPlugin.install = function (Vue) {
  Vue.prototype.$http = http
}
export let $http = http;
export default httpPlugin
